/** VIDEOWISE **/
document.addEventListener('variant:videowise', function(event) {
	window.initVideowise();
});

function setupScrollButtons(buttonEl) {
	const targetClass = buttonEl.getAttribute('data-target');
	if (!targetClass) return;

	const targetChild = document.querySelector(`.${targetClass}`);
	if (!targetChild) return;
	
	const sectionEl = targetChild.closest('.shopify-section');
	if (!sectionEl) return;

	const stickyHeader = document.querySelector('[data-sticky-type="always"]');
	const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;

	const rect = sectionEl.getBoundingClientRect();
	const offset = rect.top + window.pageYOffset - headerHeight;
	window.scrollTo({
		top: offset,
		behavior: 'smooth'
	});
}

